<a
    (click)="$event.stopPropagation()"
    href="mailto:{{ mailtoEmail }}"
    class="pill pill--email">
    <i class="uil uil-envelope-alt"></i>
    {{ mailtoEmail }}
</a>
